import {
	CampaignMember,
	Contact_Items_Active_Access__C_Enum,
	VisibilityType,
} from '../server-types';
import { hasAchievement, hash } from './misc';
import { config } from './config';
import * as Sentry from '@sentry/browser';
import { UserMagazineDataType } from './hooks';
import { UserAchievementsDataType } from './reservedContent';

export type ICanViewArgs =
	| {
			visibility: VisibilityType.Typeform;
			args: unknown;
			user: UserAchievementsDataType | null;
			isLogged: boolean;
	  }
	| {
			visibility: VisibilityType;
			args: unknown;
			user: UserMagazineDataType | null;
			isLogged: boolean;
	  };

export const canView = (visArgs: ICanViewArgs): boolean => {
	if (visArgs.visibility === VisibilityType.User) {
		if (!visArgs.user) {
			return false;
		}
		const needRole = Boolean(visArgs.args);
		if (needRole && visArgs.user.role !== visArgs.args) {
			return false;
		}
	}

	if (visArgs.visibility === VisibilityType.SfItem) {
		if (typeof visArgs.args !== 'string') {
			Sentry.captureException(new Error('Visiblità SF_ITEM con item non impostato'));
			return false;
		}

		return (
			!!visArgs.user?.Contact &&
			Array.isArray(visArgs.user.Contact.Items_Active_Access) &&
			visArgs.user.Contact.Items_Active_Access.indexOf(
				visArgs.args as Contact_Items_Active_Access__C_Enum,
			) !== -1
		);
	}

	if (visArgs.visibility === VisibilityType.SfCampaign) {
		return (
			!!visArgs.user &&
			Array.isArray(visArgs.user.campaignMemberships) &&
			visArgs.user.campaignMemberships.some(
				(c: CampaignMember) => c && c.CampaignId === visArgs.args,
			)
		);
	}

	if (visArgs.visibility === VisibilityType.SfCampaignPresente) {
		const validResults = ['test'];
		return (
			!!visArgs.user &&
			Array.isArray(visArgs.user.campaignMemberships) &&
			visArgs.user.campaignMemberships.some(
				(c: CampaignMember) =>
					c &&
					c.CampaignId === visArgs.args &&
					c.Esito_Campaign &&
					validResults.indexOf(c.Esito_Campaign) !== -1,
			)
		);
	}

	if (
		visArgs.visibility === VisibilityType.Typeform &&
		typeof visArgs.args === 'string'
	) {
		return hasAchievement(visArgs.user, visArgs.args);
	}

	if (visArgs.visibility === VisibilityType.Pardot) {
		return (
			hasAchievement(visArgs.user, 'pardot:' + hash(config.PARDOT_NEWSLETTER_FORM)) ||
			!!visArgs.user?.Prospect
		);
	}

	return true;
};


export const canViewInsights = (visArgs: ICanViewArgs): boolean => {
	if (visArgs.visibility === VisibilityType.User) {
		if (!visArgs.user) {
			return false;
		}
		const needRole = Boolean(visArgs.args);
		if (needRole && visArgs.user.role !== visArgs.args) {
			return false;
		}
	}

	if (visArgs.visibility === VisibilityType.SfItem) {
		if (typeof visArgs.args !== 'string') {
			Sentry.captureException(new Error('Visiblità SF_ITEM con item non impostato'));
			return false;
		}

		if (!!visArgs.user?.Contact &&
			Array.isArray(visArgs.user.Contact.Items_Active_Access)) {
				if (visArgs.user.Contact.Items_Active_Access.indexOf(Contact_Items_Active_Access__C_Enum.FoodDigitalePeriodicoCompleto) !== -1) {
					visArgs.user.Contact.Items_Active_Access = [
						...visArgs.user.Contact.Items_Active_Access,
						Contact_Items_Active_Access__C_Enum.FsDigitalePeriodicoCompleto,
					];
				}
		}

		return (
			!!visArgs.user?.Contact &&
			Array.isArray(visArgs.user.Contact.Items_Active_Access) &&
			visArgs.user.Contact.Items_Active_Access.indexOf(
				visArgs.args as Contact_Items_Active_Access__C_Enum,
			) !== -1
		);
	}

	if (visArgs.visibility === VisibilityType.SfCampaign) {
		return (
			!!visArgs.user &&
			Array.isArray(visArgs.user.campaignMemberships) &&
			visArgs.user.campaignMemberships.some(
				(c: CampaignMember) => c && c.CampaignId === visArgs.args,
			)
		);
	}

	if (visArgs.visibility === VisibilityType.SfCampaignPresente) {
		const validResults = ['test'];
		return (
			!!visArgs.user &&
			Array.isArray(visArgs.user.campaignMemberships) &&
			visArgs.user.campaignMemberships.some(
				(c: CampaignMember) =>
					c &&
					c.CampaignId === visArgs.args &&
					c.Esito_Campaign &&
					validResults.indexOf(c.Esito_Campaign) !== -1,
			)
		);
	}

	if (
		visArgs.visibility === VisibilityType.Typeform &&
		typeof visArgs.args === 'string'
	) {
		return hasAchievement(visArgs.user, visArgs.args);
	}

	if (visArgs.visibility === VisibilityType.Pardot) {
		return (
			hasAchievement(visArgs.user, 'pardot:' + hash(config.PARDOT_NEWSLETTER_FORM)) ||
			!!visArgs.user?.Prospect
		);
	}

	return true;
};
